import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import categoryNameToHumanReadableCategoryName from 'utils/categoryNameToHumanReadableCategoryName';
import QualityPicker from 'components/QualityPicker';
import { IAppState } from 'types/app';

interface OwnProps {
  category: string,
  isOpen: boolean,
  onChoose: () => void,
  onRequestClose: () => void,
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export class ShortlistQualityPicker extends PureComponent<Props> {
  static displayName = "ShortlistQualityPicker";
  render = () => {
    const {
      category,
      qualities,
      isOpen,
      onChoose,
      onRequestClose,
    } = this.props;

    const categoryName = categoryNameToHumanReadableCategoryName(category);

    return (
      <QualityPicker
        activateButtonLabel="Equip"
        header={`Equip your new ${categoryName}`}
        isOpen={isOpen}
        onChoose={onChoose}
        onRequestClose={onRequestClose}
        qualities={qualities.filter(q => q.category === (category || '').replace(/ /g, ''))}
      />
    );
  }
}

const mapStateToProps = ({ myself: { qualities } }: IAppState) => ({ qualities });

export default connect(mapStateToProps)(ShortlistQualityPicker);